import * as tslib_1 from "tslib";
// Third party components
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ConfigService } from 'src/app/shared/services/config.service';
// Custom components
var SlideToggleTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SlideToggleTypeComponent, _super);
    /**
     * Class constructor
     */
    function SlideToggleTypeComponent(configService, translateService, toastrService) {
        var _this = _super.call(this) || this;
        _this.configService = configService;
        _this.translateService = translateService;
        _this.toastrService = toastrService;
        return _this;
    }
    /**
     * Handle change event
     *
     * @since 1.0.0
     *
     */
    SlideToggleTypeComponent.prototype.onChange = function (checked) {
        var key = this.field.key;
        if (typeof this.model[key] !== "undefined") {
            this.model[key] = checked;
        }
    };
    return SlideToggleTypeComponent;
}(FieldType));
export { SlideToggleTypeComponent };
